export default __webpack_public_path__ + "static/MS-Sans-Serif-8pt-aa14e7b110864a3c2e08396a1b29c381.ttf";